<template>
  <ValidationObserver ref="formObserver" v-slot="{ handleSubmit }">
    <form @submit.prevent="handleSubmit(onSubmit)">
      <div class="flex border-b border-dark-b">
        <h2 class="text-xl md:text-2xl font-medium mr-6">Profile Details</h2>
      </div>
      <div class="py-12">
        <div class="md:flex">
          <ValidationProvider
            v-slot="{ errors }"
            rules="required"
            class="md:w-1/2 md:pr-5"
          >
            <label class="font-medium">First Name</label>
            <input
              class="form-input"
              type="text"
              name="First Name"
              placeholder="First Name"
              v-model="buyerAccount.first_name"
            >
            <div class="input-error">{{ errors[0] }}</div>
          </ValidationProvider>
          <ValidationProvider
            v-slot="{ errors }"
            rules="required"
            class="md:w-1/2 md:pl-5"
          >
            <label class="font-medium">Last Name</label>
            <input
              class="form-input"
              type="text"
              name="Last Name"
              placeholder="Last Name"
              v-model="buyerAccount.last_name"
            >
            <div class="input-error">{{ errors[0] }}</div>
          </ValidationProvider>
        </div>
        <div class="md:flex">
          <ValidationProvider
            v-slot="{ errors }"
            rules="required"
            name="Phone Number"
            class="md:w-1/2 md:pr-5"
          >
            <label class="font-medium">Phone Number</label>
            <div class="phone-field">
              <VuePhoneNumberInput
                v-model="buyerAccount.phone_number"
                @update="getPhoneNumber"
                :default-country-code="defaultCountry"
                class="focus:outline-none focus:border-theme h-12"
              />
              <div class="input-error">{{ errors[0] }}</div>
            </div>
          </ValidationProvider>
          <ValidationProvider
            v-slot="{ errors }"
            rules="required|email"
            class="md:w-1/2 md:pl-5"
          >
            <label class="font-medium">Email</label>
            <input
              class="form-input"
              type="text"
              name="Email"
              placeholder="Email"
              v-model="buyerAccount.email"
            >
            <div class="input-error">{{ errors[0] }}</div>
          </ValidationProvider>
        </div>
      </div>
      <div class="flex border-b border-dark-b">
        <h2 class="text-xl md:text-2xl font-medium mr-6">Company Details</h2>
      </div>
      <div class="py-12">
        <div class="md:flex">
          <ValidationProvider
            v-slot="{ errors }"
            rules="required"
            class="md:w-1/2 md:pr-5"
          >
            <label class="font-medium">Company Name</label>
            <input
              class="form-input"
              type="text"
              name="Company Name"
              placeholder="Company Name"
              v-model="buyerAccount.company_name"
            >
            <div class="input-error">{{ errors[0] }}</div>
          </ValidationProvider>
          <div class="md:w-1/2 md:pl-5 pb-5">
            <label class="font-medium">Personal Govt Proof</label>
            <div class="form-input flex relative">
              <div class="w-1/5 lg:w-3/5 h-12 flex items-center">
                <p v-if="govtProof">{{ govtProof.name }}</p>
                <a
                  v-else-if="buyerAccount.govt_proof"
                  :href="buyerAccount.govt_proof"
                  target="_blank"
                  class="text-blue w-full lg:w-auto py-3 lg:py-0"
                >
                  <span class="lg:hidden z-30">Doc</span>
                  <span class="hidden lg:block">Personal Govt. Proof</span>
                </a>
                <p v-else class="text-gray-550 whitespace-nowrap">Add Govt. Proof</p>
                <i
                  v-if="govtProof"
                  @click="removeFile('govtProof')"
                  class="material-icons absolute right-50 top-0 mt-3 mr-3 cursor-pointer z-20"
                >
                  close
                </i>
              </div>
              <div class="w-4/5 lg:w-2/5 py-2 pl-8">
                <div class="relative h-8">
                  <input
                    type="file"
                    @change="addGovtProof"
                    class="absolute inset-0 opacity-0 z-10 w-full overflow-hidden"
                    ref="govtProof"
                  >
                  <button
                    class="absolute inset-y-0 right-0 lg:inset-x-0 lg:w-full bg-dark-b rounded-full px-6 font-medium"
                    type="button" disabled
                  >Select</button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="md:flex">
          <div class="md:w-1/2 md:pr-5 pb-5">
            <label class="font-medium">Company Tax Id Number</label>
            <input
              class="form-input"
              type="text"
              name="Company Tax Id Number"
              placeholder="Company Tax ID Number"
              v-model="buyerAccount.company_tax_info"
            >
          </div>
          <div class="md:w-1/2 md:pl-5 pb-5">
            <label class="font-medium">Company Website URL</label>
            <input
              class="form-input"
              type="text"
              name="Company Website"
              placeholder="http://www.example.com"
              v-model="buyerAccount.company_website"
            >
          </div>
        </div>
        <div class="md:flex">
          <div class="md:w-1/2 md:pr-5 pb-5">
            <label class="font-medium">Company Address</label>
            <input
              class="form-input"
              type="text"
              name="Company Address"
              placeholder="Company Address"
              v-model="buyerAccount.company_address"
            >
          </div>
          <div class="md:w-1/2 md:pl-5 pb-5">
            <label class="font-medium">LinkedIn Account Link</label>
            <input
              class="form-input"
              type="text"
              name="LinkedIn Account Link"
              placeholder="LinkedIn Account Link"
              v-model="buyerAccount.linked_in_link"
            >
          </div>
        </div>
        <div class="md:flex">
          <div class="md:w-1/2 md:pr-5 pb-5">
            <label class="font-medium">Company Business Reg. Document copy</label>
            <div class="form-input flex relative">
              <div class="w-1/5 lg:w-3/5 h-12 flex items-center">
                <p v-if="companyProof">{{ companyProof.name }}</p>
                <a
                  v-else-if="buyerAccount.company_proof"
                  :href="buyerAccount.company_proof"
                  target="_blank"
                  class="text-blue w-full lg:w-auto py-3 lg:py-0"
                >
                  <span class="lg:hidden z-30">Doc</span>
                  <span class="hidden lg:block">Business Reg. Document</span>
                </a>
                <p v-else class="text-gray-550 whitespace-nowrap">Add Company Proof</p>
                <i
                  v-if="companyProof"
                  @click="removeFile('companyProof')"
                  class="material-icons absolute right-50 top-0 mt-3 mr-3 cursor-pointer z-20"
                >
                  close
                </i>
              </div>
              <div class="w-4/5 lg:w-2/5 py-2 pl-8">
                <div class="relative h-8">
                  <input
                    type="file"
                    @change="addCompanyProof"
                    class="absolute inset-0 opacity-0 z-10 w-full overflow-hidden"
                    ref="companyProof"
                  >
                  <button
                    class="absolute inset-y-0 right-0 lg:inset-x-0 lg:w-full bg-dark-b rounded-full px-6 font-medium"
                    type="button" disabled
                  >Select</button>
                </div>
              </div>
            </div>
          </div>
          <div class="md:w-1/2 md:pl-5 pb-5">
            <label class="font-medium">Company Business Reg. Number</label>
            <input
              class="form-input"
              type="text"
              name="BR Number"
              placeholder="BR Number"
              v-model="buyerAccount.br_registration_number"
            >
          </div>
        </div>
        <div class="md:flex">
          <div class="md:w-1/2 md:pr-5 pb-5 md:pb-0">
            <label class="font-medium">D&B DUNS Number</label>
            <input
              class="form-input"
              type="text"
              name="DUNS Number"
              placeholder="DUNS Number"
              v-model="buyerAccount.duns_registration_number"
            >
          </div>
          <div class="md:w-1/2 md:pl-5">
            <label class="font-medium">D&B DRS Number</label>
            <input
              class="form-input"
              type="text"
              name="DRS Number"
              placeholder="DRS Number"
              v-model="buyerAccount.drs_tpn_number"
            >
          </div>
        </div>
      </div>
      <div class="text-right pb-2.5">
        <button class="new-app-btn bg-blue">Save</button>
      </div>
    </form>
  </ValidationObserver>
</template>
<script>
import { mapActions, mapMutations } from 'vuex'
import VuePhoneNumberInput from 'vue-phone-number-input'
import 'vue-phone-number-input/dist/vue-phone-number-input.css'
import { AsYouType  } from 'libphonenumber-js/max'

export default {
  name: 'MyAccount',
  components: {
    VuePhoneNumberInput
  },
  data() {
    return {
      buyerAccount: {},
      companyProof: null,
      govtProof: null,
      defaultCountry: 'US'
    }
  },
  async created() {
    this.buyerAccount = await this.fetchBuyerAccount()
    
    const formatter = new AsYouType('US')
    let phone = `+${this.buyerAccount.country_code}${this.buyerAccount.phone_number}`
    phone = phone.replace(/"/g, '')
    formatter.input(phone)
    this.defaultCountry  = formatter.country
  },
  methods: {
    ...mapActions ([
      'fetchBuyerAccount',
      'updateBuyerAccount'
    ]),
    ...mapMutations ([
      'setUserName',
      'userLoggedIn'
    ]),
    async onSubmit() {
      const userData = new FormData()
      Object.keys(this.buyerAccount).forEach(key => {
        if (key !== 'company_proof' && key !== 'govt_proof' && key !== 'phone_number')
          userData.append(key, this.buyerAccount[key] || '')
      })
      userData.append('phone_number', this.buyerAccount.phone_number.replace(/[^0-9]+/g, ''))
      userData.append('company_proof', this.companyProof)
      userData.append('govt_proof', this.govtProof)

      const res = await this.updateBuyerAccount(userData)
      this.$notify({
        group: 'buyHive',
        type: res.result ? 'success' : 'error',
        text: res.message
      })
      this.buyerAccount = await this.fetchBuyerAccount()
      this.setUserName(`${this.buyerAccount.first_name} ${this.buyerAccount.last_name}`)
      if (res.result) {
        this.govtProof = null
        this.companyProof = null
      }
    },
    addCompanyProof(event) {
      this.companyProof = event.target.files[0]
    },
    addGovtProof(event) {
      this.govtProof = event.target.files[0]
    },
    removeFile(key) {
      this.$refs[key].value = ""
      this[key] = null
    },
    getPhoneNumber(num) {
      this.buyerAccount.country_code = num.countryCallingCode
      this.buyerAccount.phone_number = num.nationalNumber
    }
  }
}
</script>
<style lang="scss" scoped>
  @import '@/assets/styles/variables.scss';
  .phone-field {
    /deep/::placeholder {
      color: $gray_500 !important;
    }
    /deep/input.input-tel__input,
    /deep/input.country-selector__input {
      border-radius: 0.5rem !important;
      border-color: $dark-b !important;
      height: 48px !important;
      &:focus { box-shadow: none !important; }
    }
    /deep/label {
      color: $gray_500 !important;
    }
  }
</style>
